import React, { Component } from 'react'
import { EditorState, RichUtils } from 'draft-js'
import { convertFromHTML, convertToHTML } from 'draft-convert'
import { Editor as DraftEditor, KeyCommandController } from 'draft-extend'
import { compose } from 'ramda'
import cx from 'classnames'

import CalendarPlugin from './plugins/calendar'
import TokenPlugin from './plugins/token'
import BlockPlugin from './plugins/blockStyles'
import LinkPlugin from './plugins/link'
import ImagePlugin from './plugins/image'
import ParagraphPlugin from './plugins/paragraph'
import dompurify from 'dompurify'

import 'draft-js/dist/Draft.css'
import './style.styl'

const plugins = compose(BlockPlugin, LinkPlugin, ImagePlugin, ParagraphPlugin, TokenPlugin, CalendarPlugin)
const WithPlugins = plugins(DraftEditor)
const toHTML = plugins(convertToHTML)
const fromHTML = plugins(convertFromHTML)

class Editor extends Component {
  constructor(props) {
    super(props)
    const purifiedMessage = dompurify.sanitize(props.value)
    const contentState = fromHTML(purifiedMessage)
    this.state = {
      editorState: EditorState.createWithContent(contentState),
    }
    this.handleOutgoingChange = _.debounce(() => {
      const value = toHTML(this.state.editorState.getCurrentContent())
        .replace(/&quot;/g, '"')  // escape jinja values
        .replace(/&#x27;/g, "'")  // escape jinja values
        .replace(/&lt;/g, '<')  // escape jinja values
        .replace(/&gt;/g, '>')  // escape jinja values
        .replace(/<div><\/div>/g, '<br />')
      const sanitized = dompurify.sanitize(value)  // replace empty blocks with empty lines
      this.props.onChange(this.state.editorState.getCurrentContent().hasText() ? sanitized : '')
      this.props.setIsTyping && this.props.setIsTyping(false)
    }, 400) // give it some time to save playbook, otherwise input delays. toHTML() is HEAVY...
  }

  editorStateChanged(oldState, newState) {
    return oldState.getCurrentContent() !== newState.getCurrentContent()
  }

  handleChange = editorState => {
    const didContentChange = this.editorStateChanged(this.state.editorState, editorState)
    if (this.props.setIsTyping && didContentChange) {
      this.props.setIsTyping(true)
      if (this.previousTypingTimeoutId) {
        clearTimeout(this.previousTypingTimeoutId)
      }
      this.previousTypingTimeoutId = setTimeout(() => {
        this.props.setIsTyping(false)
      }, 450)
    }
    this.setState({ editorState }, didContentChange ? this.handleOutgoingChange : null)
  }

  handleKeyCommand = (command, editorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command)
    if (newState) {
      this.handleChange(newState)
      return 'handled'
    }
    return 'not-handled'
  }

  render() {
    const { editorState } = this.state
    const { className, popoverAnchorBottom, removeKeyCommandListener, noPersonalization, addKeyCommandListener, enableDynamicCalendarLink } = this.props

    return (
      <div className={cx('rich-editor', className)}>
        <WithPlugins
          editorState={editorState}
          handleKeyCommand={this.handleKeyCommand}
          onChange={this.handleChange}
          addKeyCommandListener={addKeyCommandListener}
          removeKeyCommandListener={removeKeyCommandListener}
          noPersonalization={noPersonalization}
          enableDynamicCalendarLink={enableDynamicCalendarLink}
          popoverAnchorBottom={popoverAnchorBottom}
        />
      </div>
    )
  }
}

export default KeyCommandController(Editor)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Editor/index.js